<template>
  <div>
    <!-- bloc note -->
    <div class="container-fluid" style="height: 65px">
      <router-link
        :to="{
          name: 'miseAJourBlocNote',
          params: { id: all_image[0].id },
        }"
      >
        <CButton
          style="
            margin-bottom: 7px;
            border-radius: 15px 18px;
            margin-top: -18px;
            margin-left: -8px;
          "
          color="success"
          class="mr-1 cl"
        >
          Nouveau
        </CButton>
      </router-link>
      <router-link to="/listes_bloc_note">
        <CButton
          style="
            margin-bottom: 7px;
            border-radius: 15px 18px;
            margin-top: -18px;
            margin-left: 26px;
          "
          color="info"
          class="mr-1 cl"
        >
          Listes Bloc Notes
        </CButton>
      </router-link>
      <form>
        <div class="row">
          <div class="col">
            <!-- <label>Nom du chauffeur</label> -->

            <div class="form-group">
              <!-- <label>Nom</label> -->
              <input
                disabled
                aria-label="label"
                type="text"
                class="form-control personalise"
                placeholder="Nom et Prénom *"
                v-model="all_image[0].nom"
              />
            </div>
          </div>
        </div>
        <!--   </b-card-text>
      </b-card> -->
        <div class="row" v-for="(list, index) in listes_bloc_note" :key="index">
          <b-card
            style="
              border: solid 1px #f5a623;
              padding: 0px;
              width: 100%;
              margin-left: 1rem !important;
              margin-right: 1rem !important;
              background-color: #ebedef !important;
            "
          >
            <CCol sm="12">
              <div class="form-group">
                <label>Date</label>

                <VueDatePicker disabled class="form-control" v-model="list.date" />
              </div>
            </CCol>

            <CCol sm="12">
              <div class="form-group">
                <!--   <label  style="color:black;">Ajouter votre description ici:</label>   -->
                <textarea
                disabled
                  aria-label="description"
                  v-model="list.titre"
                  placeholder="Ajouter votre description ici ..."
                  addon-left-icon="ni ni-circle-08"
                  class="form-control"
                  id="description"
                  rows="4"
                  required
                ></textarea>
                <!--    <span class="text-red"  v-if="errors.description">{{errors.description[0]}}</span> -->
              </div>
              <hr
                style="padding: 5px; border-top: 3px solid #a12828 !important"
              />
              <div>
                <img
                  @click="delete_bloc_note(list.id)"
                  style="margin-left: 4px;"
                  src="sup.png"
                />
                &nbsp;
                &nbsp;
                <router-link
                  style="color: #4f5d73"
                  :to="{
                    name: 'edit_ajouterBlocNote',
                    params: { id: list.id },
                  }"
                >
                <img
                
                  style="margin-left: 4px;"
                  src="mod.png"
                />
                </router-link>
               
              </div>
            </CCol>
            <!--  <CButton
              @click.prevent="create"
              type="submit"
              size="sm"
              color="info"
              style="border-radius: 24px; margin-left: 22px"
              ><CIcon name="cil-check-circle" /> Modifier
            </CButton> -->
            <div
              class="row"
              v-for="(item, index) in list.images_bloc"
              :key="index"
            >
              <div class="col">
                <div class="form-group">
                  <img
                    class="preview"
                    :src="`${apiDomain}/myapp/public/uploads/files_bloc/${item.image}`"
                  />
                </div>
              </div>
            </div>
          </b-card>
        </div>
      </form>
    </div>

    <!-- fin bloc note -->
  </div>
</template>


<style lang="scss" scoped>
.md-card {
  width: 98%;
  margin: 4px;
  margin-left: 11px;
  display: inline-block;
  vertical-align: top;
}
</style>


<script>
import Vue from "vue";
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import { apiDomain } from "../../config";
import axios from "axios";
export default {
  components: { VueDatePicker },
  name: "register",
  data() {
    return {
      description: "",
      nom: "",
      selectedDate: new Date().toISOString().split("T")[0],
      imageData: "",
      errors: {},
      /* -------------- */
      listes_bloc_note: {},
      all_image: {},
      apiDomain: "https://apil.auto-turki.com",
    };
  },
  created() {
    this.fetchBlocNote(this.$route.params.id);
    this.fetchBlocNoteImage(this.$route.params.id);
  },
  mounted() {},
  computed: {},
  methods: {
    /* tabs */
    previewImage: function (event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = (e) => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },

    fetchBlocNote(id) {
      fetch(`${apiDomain}/api/get_detail_bloc/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.listes_bloc_note = res;
        })
        .catch((err) => console.log(err));
    },

    delete_bloc_note(id) {
      if (confirm("Azouz SVP Vérifier Sure ?")) {
      fetch(`${apiDomain}/api/delete_detail_bloc/${id}`, {
        method: "delete",
      })
        .then((res) => res.json())
        .then((data) => {
          this.$noty.success("Bloc note  supprimer avec Succès ! ");
          this.fetchBlocNote(this.$route.params.id);
        })

        .catch((err) => console.log(err));
      }
    },
    fetchBlocNoteImage(id) {
      fetch(`${apiDomain}/api/get_all_image_Bloque_id/${this.$route.params.id}`)
        .then((res) => res.json())
        .then((res) => {
          this.all_image = res;
        })
        .catch((err) => console.log(err));
    },

    create(e) {
      let formData = new FormData();
      formData.append("date", this.listes_bloc_note[0].date);

      /* formData.append("nom", this.listes_bloc_note[0].nom); */
      formData.append("titre", this.listes_bloc_note[0].titre);

      //somme

      axios
        .post(
          `${apiDomain}/api/Updated_bloc/${this.$route.params.id}`,
          formData
        )

        .then((res) => {
          this.$noty.success("Bloc note  modifier avec Succès ! ");

          this.$router.push("/listes_bloc_note");

          // this.fetchsearch();
        })
        .catch((error) => {
          if (error.response.status == 422) {
            this.showPart1 = true;
            this.showPart2 = false;
            this.showPart3 = false;
            this.errors = error.response.data.errors;
            this.$noty.error("OOPS ! il y a une erreur essayé de vérifier ");
          }
          if (error.response && error.response.status == 400) {
            this.validationErrors = error.response.data;
          }
        });
    },
  },
};
</script>


<style>
.file-upload-form,
.image-preview {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  padding: -6px;
}
img.preview {
  width: 50px;
  height: 173px;
  background-color: white;
  border: 1px solid #ddd;
}
</style>

